import {
    PARTICIPANT_FAILURE,
    PARTICIPANT_REQUEST,
    PARTICIPANT_SUCCESS,
    PARTICIPANT_POST_SUCCESS,
    PARTICIPANT_DELETE_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
    // WHICH competition `data` holds. Participants are fetched per
    // competition — the unfiltered collection is far too large for the API to
    // serialize — so a consumer must know whether the rows in the store are
    // the ones it asked for before trusting isFetched.
    fetchedCompetition: null,
};

export const listReducer = (state = initialState, action) => {
    const { type, data, participant } = action;
    switch (type) {
        case PARTICIPANT_DELETE_SUCCESS: {
            const newData = state.data.filter(d => d.id !== participant)
            return {
                ...state,
                data: [...newData]
            }
        }

        case PARTICIPANT_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, participant]
            }
        }

        case PARTICIPANT_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            fetchedCompetition: action.competitionId || null,
            data: preserveArrayReference(state.data, data),
        }}

        case PARTICIPANT_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case PARTICIPANT_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
